import { useEffect, useMemo } from "react";

import { usePageNameContext } from "../../contexts/PageTitleContext";
import useMarketplaceListingsSample from "../../data/useMarketplaceListingsSample";
import MarketplaceBreakdown from "../../components/ebayListings/marketplaceInsights/MarketplaceBreakdown";
import MarketplaceInsightsStats from "../../components/ebayListings/marketplaceInsights/MarketplaceInsightsStats";
import StaleListingsTable from "../../components/ebayListings/marketplaceInsights/StaleListingsTable";
import TopViewedListingsTable from "../../components/ebayListings/marketplaceInsights/TopViewedListingsTable";
import { enrichListings } from "../../components/ebayListings/marketplaceInsights/marketplaceInsightsHelpers";

export default function MarketplaceInsights() {
  const { setInfo } = usePageNameContext();
  const { parts, listings } = useMarketplaceListingsSample(250);

  useEffect(() => {
    setInfo({
      name: "Marketplace Insights",
      desc: "See how your eBay & Shopify listings are performing — spot winners and optimise stale stock.",
    });
  }, []);

  const enriched = useMemo(() => enrichListings(parts), [parts]);

  return (
    <div className="mt-4 flex flex-col gap-4 pb-10">
      <MarketplaceInsightsStats listings={enriched} />

      <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
        <TopViewedListingsTable
          listings={enriched}
          isLoading={listings.isLoading}
        />
        <StaleListingsTable
          listings={enriched}
          isLoading={listings.isLoading}
        />
      </div>

      <MarketplaceBreakdown />

      <p className="text-xs text-slate-500">
        View counts for the last 30 days are derived from the running eBay /
        Shopify totals on each listing. Numbers sharpen up as the backend
        starts supplying the rolling-window figures directly.
      </p>
    </div>
  );
}
